@if (loaderService.loading()) {
  <div class="fixed inset-0 z-[99999] flex items-center justify-center 
              bg-black/5 backdrop-blur-[1px]">

    <div class="flex flex-col items-center gap-4">

      <!-- Spinner -->
      <div class="h-14 w-14 animate-spin rounded-full 
                  border-4 border-blue-500 border-t-transparent">
      </div>

      <!-- Text -->
      <p class="text-gray-700 text-sm tracking-wide">
        {{ loaderService.message() }}
      </p>

    </div>

  </div>
}
